module.exports = __webpack_public_path__ + "static/media/arbitrationNoticeBtnEng.d68ccc7c.png";